<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getAllRefunds} from 'src/components/cabinet/#services/refunds'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'

    let currentPage = 0
    let perPage = 25
    let loadingTransactions = []

    loadingTransactions.length = perPage
    getAllRefunds.send({ data: { page: currentPage + 1, perPage }})
    $getAllRefunds.value

    function filter() {
        getAllRefunds.send({ data: { page: currentPage + 1, perPage }})
        $getAllRefunds.value
    }
    $:currentPage,perPage,filter()

    const productDescription = {
        'offer_additional_hangar1_gp': 'Additional hangar 1',
        'offer_additional_hangar2_gp': 'Additional hangar 2',
        'offer_auto_merge_gp': 'Auto merge offer',
        'offer_last_chance2_gp': 'Last chance 2 offer',
        'offer_last_chance3_gp': 'Last chance 3 offer',
        'offer_last_chance4_gp': 'Last chance 4 offer',
        'offer_last_chance_gp': 'Last chance offer',
        'offer_offline_earning_gp': 'Offline earning offer',
        'offer_starter_pack_gp': 'Starter pack offer',
        'starter_pack_gp': 'Starter pack offer',
        'offer_wall_street_card_gp': 'Wall street card offer',
        'offer_weekly_tournament_gp': 'Weekly tournament offer',
        'offer_xmas_special_gp': 'Christmas offer',
        'soul_buy1_gp': 'Bought LIS 1',
        'soul_buy2_gp': 'Bought LIS 2',
        'soul_buy3_gp': 'Bought LIS 3',
        'soul_buy4_gp': 'Bought LIS 4',
        'soul_buy5_gp': 'Bought LIS 5',
        'soul_buy6_gp': 'Bought LIS 6',
        'status_buy3_gp': 'Silver membership',
        'status_buy4_gp': 'Gold membership',
        'status_buy5_gp': 'Platinum membership',
    }
</script>

<svelte:head>
    <title>Refunds</title>
</svelte:head>

<MainLayout title="Refunds">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="transactions-list">
                    <Table bordered striped responsive>
                        <thead>
                        <tr>
                            <td class="text-center">Date</td>
                            <td class="text-center">User</td>
                            <td class="text-center">Product</td>
                            <td class="text-center">Order ID</td>
                        </tr>
                        </thead>
                        <tbody>
                        {#if $getAllRefunds.loading}
                            {#each {length:perPage} as item}
                                <tr>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                </tr>
                            {/each}
                        {:else if $getAllRefunds.error || !$getAllRefunds.hasValue }
                            <tr>
                                <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
                            </tr>
                        {:else}
                            {#each $getAllRefunds.value.refunds as { userId, orderId, productId, email, date }}
                                <tr>
                                    <td class="text-center">{new Date(date).toLocaleString()}</td>
                                    <td class="text-center">
                                        {#if userId}
                                            <a href="profile/{userId}" class="reason" target="_blank" rel="noreferrer">
                                                {#if email}
                                                    {email}
                                                {:else}
                                                    {userId}
                                                {/if}
                                            </a>
                                        {/if}
                                    </td>
                                    <td class="text-center">
                                        {#if productDescription[productId]}
                                            <span title="{productId}">{productDescription[productId]}</span>
                                        {:else}
                                            {productId}
                                        {/if}
                                    </td>
                                    <td class="text-center notranslate">
                                        <a href="https://play.google.com/console/u/0/developers/5329690909234469933/orders/{orderId}" target="_blank" rel="noreferrer">
                                            {orderId}
                                        </a>
                                    </td>
                                </tr>
                            {:else}
                                <tr>
                                    <td class="text-center" colspan="4">No items</td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                    {#if $getAllRefunds.hasValue}
                        <PerPage bind:perPage={perPage} disabled={$getAllRefunds.loading || $getAllRefunds.loading}/>
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$getAllRefunds.value.totalCount}
                            {perPage}
                            disabled={$getAllRefunds.loading || $getAllRefunds.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    .form-select {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .date-label {
        padding: 0 5px;
        line-height: 38px;
        font-weight: 500;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
    }

    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .date-label {
            font-size: 14px;
        }

        .btn-filter {
            margin-bottom: 10px;
        }
    }
</style>
